import { L10n } from '@skylab-shared/core';
import { Singleton } from '@skylab-shared/utils';
import { UserLanguageLoader } from './user-language-loader';

@Singleton
class TranslationLoaderBase {

    public async loadAsync(): Promise<void> {
        try {
            const language = await UserLanguageLoader.loadLanguageAsync();
            await L10n.setLangAsync(language);
        } catch (err) {
            throw new Error(err instanceof Error ? err.message : String(err));
        }
    }
}

export const TranslationLoader = new TranslationLoaderBase();
